import React, { useState } from 'react';
import { Card, Button, Modal, Form, Input, DatePicker, Space, Tag, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { updateStudent } from '../../api/students';
import StudentBadgesPanel from './StudentBadgesPanel';
import SchoolSelect from '../common/SchoolSelect';
import { apiErrorMessage } from '../../utils/apiError';

const StudentInfoTab = ({ student, onUpdate }) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleEdit = async (values) => {
    try {
      await updateStudent(student.id, {
        ...values,
        birth_date: values.birth_date ? values.birth_date.format('YYYY-MM-DD') : null,
      });
      message.success('Öğrenci güncellendi.');
      setEditModalOpen(false);
      onUpdate();
    } catch (error) {
      message.error(apiErrorMessage(error, 'Güncelleme başarısız.'));
    }
  };

  return (
    <>
      <StudentBadgesPanel studentId={student.id} />

      <Card
        extra={
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              form.setFieldsValue({
                ...student,
                birth_date: student.birth_date ? dayjs(student.birth_date) : null,
              });
              setEditModalOpen(true);
            }}
          >
            Düzenle
          </Button>
        }
      >
        <div className="grid grid-cols-2 gap-4">
          <div><strong>TC Kimlik:</strong> {student.tc_no || '—'}</div>
          <div><strong>Doğum Tarihi:</strong> {student.birth_date ? dayjs(student.birth_date).format('DD.MM.YYYY') : '—'}</div>
          {/* Katalogdaki ad esas; henüz bağlanmamış kayıtlarda ham metin
              gösteriliyor ki bilgi kaybolmasın (okul kataloğu taşıması,
              2026-08-06 — kayıtların ~%15'i elle düzeltilecek). */}
          <div>
            <strong>Okul:</strong> {student.school_record?.name || student.school || '—'}
            {!student.school_record && student.school && (
              <Tag color="orange" style={{ marginLeft: 8 }}>Listeye bağlanmamış</Tag>
            )}
          </div>
          <div><strong>Şube:</strong> {student.branch?.name || '—'}</div>
          <div className="col-span-2">
            <strong>Adres:</strong>{' '}
            {student.address
              ? `${student.address}${student.district ? ', ' + student.district : ''}${student.city ? ' / ' + student.city : ''}${student.postal_code ? ' ' + student.postal_code : ''}`
              : '—'}
          </div>
        </div>
      </Card>

      <Modal
        title="Öğrenci Düzenle"
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        footer={null}
        width={600}
      >
        <Form form={form} layout="vertical" onFinish={handleEdit}>
          <div className="grid grid-cols-2 gap-4">
            <Form.Item name="name" label="Ad" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="surname" label="Soyad" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Form.Item name="tc_no" label="TC Kimlik No">
              <Input maxLength={11} />
            </Form.Item>
            <Form.Item name="birth_date" label="Doğum Tarihi">
              <DatePicker format="DD.MM.YYYY" style={{ width: '100%' }} />
            </Form.Item>
          </div>
          {/* Serbest metin DEĞİL: okul artık katalogdan seçiliyor. Listede
              olmayan bir okul varsa Okullar sayfasından eklenir. */}
          <Form.Item
            name="school_id"
            label="Okul"
            extra={!student.school_record && student.school
              ? `Kayıtlı metin: "${student.school}" — listeden doğru okulu seçin.`
              : undefined}
          >
            <SchoolSelect
              style={{ width: '100%' }}
              initialOption={student.school_record || undefined}
            />
          </Form.Item>

          {/* Fatura icin gerekli - e-Arsiv alicinin acik adresini, il ve ilcesini
              AYRI alanlar olarak zorunlu kiliyor. Kayit sirasinda zorunlu degil,
              fatura kesilecegi zaman doldurulur. */}
          <Form.Item
            name="address"
            label="Adres"
            extra="Fatura kesilebilmesi için gerekli"
          >
            <Input placeholder="Mahalle, cadde/sokak, kapı no" />
          </Form.Item>
          <div className="grid grid-cols-3 gap-4">
            <Form.Item name="district" label="İlçe">
              <Input />
            </Form.Item>
            <Form.Item name="city" label="İl">
              <Input />
            </Form.Item>
            <Form.Item name="postal_code" label="Posta Kodu">
              <Input maxLength={10} />
            </Form.Item>
          </div>

          <Form.Item className="mb-0 flex justify-end">
            <Space>
              <Button onClick={() => setEditModalOpen(false)}>İptal</Button>
              <Button type="primary" htmlType="submit">Güncelle</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default StudentInfoTab;